<template>
  <app-body
    :app-title="title"
    :background="background"
  />
</template>

<script>
/* eslint-disable no-restricted-globals */
  import { DeviceDetector } from '@/utils/device-detector';
  import { AppBody } from '@/components/body';
  import { translate } from '@/i18n';
  import { Background } from './assets/background';

  export default {
    name: 'app',
    components: {
      AppBody
    },
    data() {
      return {
        redirect: {
          iOS: 'https://apps.apple.com/ru/app/bork/id1411917010',
          android: 'https://play.google.com/store/apps/details?id=com.syncleoiot.bork&hl=ru'
        }
      };
    },
    computed: {
      title() {
        return location.pathname === '/'
          ? translate('body.text')
          : translate('body.notFound');
      },
      background() {
        if (location.pathname === '/') {
          return DeviceDetector.isMobile()
            ? translate('body.background.mobile')
            : translate('body.background.desktop');
        }

        return Background.notFound;
      }
    }
  };
</script>

<style lang="scss">
  body {
    margin: 0;
    padding: 0;
  }
</style>
